import _regeneratorRuntime from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _inherits from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";
import _createSuper from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/createSuper.js";
import AvueSelectTemplateService from "../AvueSelectTemplateService";
import { querySupplyDict } from "../../../api/financialApi";
var SupplyAvueSelectTemplateImpl = /*#__PURE__*/function (_AvueSelectTemplateSe) {
  _inherits(SupplyAvueSelectTemplateImpl, _AvueSelectTemplateSe);
  var _super = _createSuper(SupplyAvueSelectTemplateImpl);
  function SupplyAvueSelectTemplateImpl() {
    _classCallCheck(this, SupplyAvueSelectTemplateImpl);
    return _super.apply(this, arguments);
  }
  _createClass(SupplyAvueSelectTemplateImpl, [{
    key: "abstractQueryDictData",
    value: function () {
      var _abstractQueryDictData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dictType) {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return querySupplyDict(dictType);
              case 2:
                response = _context.sent;
                return _context.abrupt("return", response);
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function abstractQueryDictData(_x) {
        return _abstractQueryDictData.apply(this, arguments);
      }
      return abstractQueryDictData;
    }()
  }]);
  return SupplyAvueSelectTemplateImpl;
}(AvueSelectTemplateService);
export { SupplyAvueSelectTemplateImpl as default };